import {updateAutoAdd, list} from "@/services/api/app/google/seat-management/classroom/backupSettings";

const defaultState = () => ({
  autoAdd: {
    classroom: true,
  },
});

export default {
  namespaced: true,

  actions: {
    list({commit}) {
      return list()
        .then((data) => {
          if (data?.autoAdd) {
            commit('setAutoAdd', data.autoAdd)
          }
        })
    },
    updateAutoAdd({commit}, data) {
      return updateAutoAdd(data)
        .then(({autoAdd}) => {
          commit('setAutoAdd', autoAdd)
        })
    },
  },

  mutations: {
    setAutoAdd(state, autoAdd) {
      state.autoAdd = autoAdd
    },
  },


  getters: {
    //seatType: classroom
    getAutoAddSettingByType: (state) => (seatType) => {
      return state.autoAdd && state.autoAdd[seatType];
    },
  },

  state: defaultState
}
